import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import CatHelper from '@iso/lib/api/catHelper';
import { notification } from '@iso/components';
import actions from './actions';
import {redirectPage} from '@iso/lib/helpers/utility';

//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* CatReadRequest() {
    yield takeEvery(actions.CAT_LIST, function*({ payload }) {
    try {
        //const {page}=payload.page;
      const searchResult = yield call(CatHelper.read,payload);
      console.log('---serachResult--', searchResult )
      if (searchResult.status) {
        yield put(
          actions.catListSuccess(
            searchResult.exportresult,  
          searchResult.result,
          searchResult.status,
          searchResult.totalRecordCount,
           payload.page
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(
          actions.catListSuccess([],[],0,0, 1)
        );
      }
    } catch (error) {
    }
  });
}
/*****fetch user record  *************/



/**** list of user record *******/
export  function* CatFindByIdRequest() {
  console.log('search request');
    yield takeEvery(actions.CAT_FETCH_ID, function*({ payload }) {
    try {
      const searchResult = yield call(CatHelper.findById,payload.listid);
      if (searchResult.status) {
        console.log('searchResult11111', searchResult)
        yield put(
          actions.catListById(
          searchResult.result,
          searchResult.message,
          searchResult.countryNpxInfo
          )
        );
      } else if (searchResult.status === 0){
        redirectPage("/404")
      }
    } catch (error) {
    }
  });
}

/********** attribute edit by MGC function *********/
export function* attUpdateRequest() {
  yield takeEvery(actions.CAT_EDIT_BY_MGC, function* ({ payload }){
    const result = yield call(CatHelper.updateAttByMgc,payload.info);

    console.log("AYUSHYAAAAAA--------", result)
    if (result.status === 0) {
      notification('error', result.message);
    } else {
      notification('success', result.message);
      console.log(result);
      // yield put({
      //   type: actions.ITEM_EDIT_SUCCESS,
      //   success: true,
      //   msg: result.message,
      // });
      payload.history.push('/dashboard/categorydetails/'+ payload.id);
      window.location.reload()
    }
  });
}
/*****end*************/

/********** attribute edit by MGC function *********/
export function* nutAttUpdateRequest() {
  yield takeEvery(actions.CAT_NUT_EDIT_BY_ID, function* ({ payload }){
 //    var id = payload.info._id
  //   console.log(payload.info._id,'payload----')
    const result = yield call(CatHelper.updateNutAttById,payload.info);

   // console.log("amit===", result)
    if (result.status === 0) {
      notification('error', result.message);
    } else {
      notification('success', result.message);
      console.log(result);
      // yield put({
      //   type: actions.ITEM_EDIT_SUCCESS,
      //   success: true,
      //   msg: result.message,
      // });
      payload.history.push('/dashboard/categorydetails/'+payload.id);
      window.location.reload();
    }
  });
}
/*****end*************/

/**
 * For adding new Leaf Category
 */
function* CatLeafAddRequest() {
  yield takeEvery(actions.CAT_LEAF_ADD, function* ({ payload }) {
    console.log('payload', payload)
    try {
      const result = yield call(CatHelper.leafAdd, payload.dataObj);
      console.log("result", result);
      if (result.status === 0) {
        notification("error", result.message);
      } else {
        notification("success", result.message);
        if(payload.dataObj.type && payload.dataObj.type === "edit"){
          window.location.reload(true)
        }else{
          payload.history.push("/dashboard/categorytree");
        }
        
      }
    } catch (error) {}
  });
}

/**
 * Soft Delete Category
 */
function* CatLeafDelRequest() {
  yield takeEvery(actions.CAT_LEAF_DELETE, function* ({ payload }) {
    try {
      const result = yield call(CatHelper.leafDelete, payload.dataObj);
      if (result.status === 0) {
        notification("error", result.message);
        payload.history.push("/dashboard/categorytree");
      } else {
        notification("success", result.message);
        payload.history.push("/dashboard/categorytree");
      }
    } catch (error) {}
  });
}

/** Get Diabtese Colors Values*/
export  function* getDiabtese() {
    yield takeEvery(actions.COLOR_GET_DIABETES, function*({ payload }) {
    try {
      const searchResult = yield call(CatHelper.diabteseColorValGet,payload);
      if (searchResult.status) {
        yield put(
          actions.diabteseColorSet(
          searchResult.result,
          )
        );
      } else if (searchResult.status === 0){
        redirectPage("/404")
      }
    } catch (error) {
    }
  });
}
/** Get TLL Colors Values*/
export  function* getTLL() {
  yield takeEvery(actions.COLOR_GET_TLL, function*({ payload }) {
  try {
    const searchResult = yield call(CatHelper.TLLValGet,payload);
    if (searchResult.status) {
      yield put(
        actions.TLLColorSet(
        searchResult.result,
        )
      );
    } else if (searchResult.status === 0){
      redirectPage("/404")
    }
  } catch (error) {
  }
});
}
/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(CatReadRequest),
    fork(CatFindByIdRequest),
    fork(attUpdateRequest),
    fork(nutAttUpdateRequest), 
    fork(CatLeafAddRequest), 
    fork(CatLeafDelRequest), 
    fork(getDiabtese),
    fork(getTLL)
  ]);
}
